import { render, staticRenderFns } from "./EditCaptionModal.vue?vue&type=template&id=4a54c476"
import script from "./EditCaptionModal.vue?vue&type=script&lang=js"
export * from "./EditCaptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports